export default "__VITE_ASSET__Cd4uSOAF__"